<template>
  <!-- Figma S&R flow "Select a Unit" (5549:4055): breadcrumb, stepper, form card + Details/notes card -->
  <main class="selectUnitPg w-full relative">
    <EvalShell title="Select a Unit" :step="1" :job-id="jobId" :show-back="!hideTopBack">
      <template #title-extra>
        <span v-if="units[currentIndex]?.is_agreement == 1" :title="units[currentIndex]?.agreement_name"
          class="flex items-center gap-[8px] h-[30px] px-[10px] rounded-[8px] border-[1px] border-[#C2E2F9] bg-[#E9F5FE] text-[12px] desktop:text-[13px] font-medium text-[#2A7BB8]">
          <span class="w-[18px] h-[18px] rounded-full flex items-center justify-center bg-[#38BDF8]">
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 64 64">
              <path d="M0 0h64v64H0z" fill="none" />
              <path fill="#fff" d="M56 2L18.8 42.909L8 34.729H2L18.8 62L62 2z" />
            </svg>
          </span>
          Service Agreement
        </span>
        <span v-if="isUnitsApiHit"
          class="flex items-center gap-[10px] h-[36px] pl-[16px] pr-[8px] rounded-[18px] bg-[#F4F5FB] text-[14px] font-roboto text-[#5B616B] whitespace-nowrap">
          Available Units:
          <span
            class="w-[26px] h-[26px] rounded-full flex items-center justify-center bg-[#3B82F6] text-white text-[13px]">{{
              units.length }}</span>
        </span>
      </template>
      <!-- Figma "Select a Unit — Multiple Units" (5540:3204): with more than one unit, pick one from the list first;
           Next opens its form ("Select a Unit" 5549:4055), Back on the form returns to the list -->
      <template v-if="showList">
        <div
          class="flex items-start gap-[12px] mb-[20px] px-[18px] py-[12px] rounded-[10px] border-1 border-[#BFD7F5] bg-[#EAF3FD] font-roboto">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24">
            <path d="M0 0h24v24H0z" fill="none" />
            <g fill="none" stroke="#2563eb" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
              <path
                d="M20.3692 8.5334C21.4021 9.3883 22 10.6592 22 12C22 13.3408 21.4021 14.6117 20.3692 15.4666C20.3825 15.6071 20.3891 15.748 20.3891 15.8891C20.3891 18.3744 18.3744 20.3891 15.8891 20.3891C15.748 20.3891 15.6071 20.3825 15.4666 20.3692C14.6117 21.4021 13.3408 22 12 22C10.6592 22 9.3883 21.4021 8.5334 20.3692C8.3929 20.3825 8.252 20.3891 8.1109 20.3891C5.6256 20.3891 3.6109 18.3744 3.6109 15.8891C3.6109 15.748 3.6175 15.6071 3.6308 15.4666C2.5979 14.6117 2 13.3408 2 12C2 10.6592 2.5979 9.3883 3.6308 8.5334C3.6175 8.3929 3.6109 8.252 3.6109 8.1109C3.6109 5.6256 5.6256 3.6109 8.1109 3.6109C8.252 3.6109 8.3929 3.6175 8.5334 3.6308C9.3883 2.5979 10.6592 2 12 2C13.3408 2 14.6117 2.5979 15.4666 3.6308C15.6071 3.6175 15.748 3.6109 15.8891 3.6109C18.3744 3.6109 20.3891 5.6256 20.3891 8.1109C20.3891 8.252 20.3825 8.3929 20.3692 8.5334Z" />
              <path d="M12 17V11" />
              <path fill="#2563eb"
                d="M13 7C13 6.4477 12.5523 6 12 6C11.4477 6 11 6.4477 11 7C11 7.5523 11.4477 8 12 8C12.5523 8 13 7.5523 13 7Z"
                stroke="none" />
            </g>
          </svg>

          <p class="m-0 text-[13px] font-medium leading-[21px] text-[#2A5EA8]">
            <span class="text-[14px] font-semibold text-[#1E4E9C]">Only one unit can be diagnosed per
              booking.</span><br>
            To diagnose another unit, create a separate booking.
          </p>
        </div>
        <div class="flex flex-wrap items-center justify-between gap-2 mb-[10px] font-roboto">
          <div class="flex flex-col">
            <p class="m-0 text-[16px] font-medium text-[#2E3138]">Select the unit for this booking</p>
            <span class="laptop:hidden font-roboto text-[13px] text-[#8A9099]">{{ units.length }} units at this
              address</span>
          </div>
          <button v-if="isAddOptionCheck()" type="button"
            class="flex items-center mobile:gap-[6px] laptop:gap-[8px] mobile:h-[30px] laptop:h-[36px] mobile:pl-[3px] laptop:pl-[4px] mobile:pr-[12px] laptop:pr-[14px] rounded-full border-1 font-roboto mobile:text-[13px] laptop:text-[14px] mobile:bg-[#14C38E] mobile:border-[#14C38E] mobile:text-white laptop:bg-[#fff] laptop:border-[#E9ECF1] laptop:text-[#333333]"
            @click="addMoreUnits()">
            <!-- below laptop filled green (Figma mobile), the + circle gets a white ring -->
            <span
              class="mobile:w-[24px] mobile:h-[24px] laptop:w-[28px] laptop:h-[28px] rounded-full flex items-center justify-center bg-[#14C38E] mobile:border-[1.5px] mobile:border-white laptop:border-0">
              <svg width="12" height="12" viewBox="0 0 14 14" fill="none">
                <path d="M7 1.5v11M1.5 7h11" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" />
              </svg>
            </span>
            Add Unit
          </button>
        </div>
        <p v-if="!units.length"
          class="m-0 mb-[20px] px-[18px] py-[30px] rounded-[10px] border-1 border-dashed border-[#CCCCCC] text-center text-[14px] text-[#8A9099] font-roboto">
          No units at this address yet. Add a unit to start the evaluation.
        </p>
        <div v-else
          class="flex items-center justify-end laptop:justify-between gap-2 mb-[10px] font-roboto text-[13px] text-[#8A9099]">
          <span class="hidden laptop:block">{{ units.length }} units at this address</span>
          <span v-if="units.length > 4">Scroll for more</span>
        </div>
        <ul ref="unitList"
          class="list-none m-0 mb-[20px] p-[4px] flex flex-col gap-[10px] max-h-[340px] overflow-y-auto customscrollbar font-roboto">
        <!-- just for desktop/Tab -->
          <li v-for="(item, index) in units" :key="index" class="mobile:hidden tablet:block">
            <button type="button"
              class="w-full items-center mobile:gap-[10px] laptop:gap-[16px] mobile:px-[14px] laptop:px-[18px] py-[14px] rounded-[10px] text-left flex"
              :class="index == currentIndex ? 'bg-[#F4F5FB] border-[2px] border-[#7C8CE8]' : 'bg-white border-[2px] border-[#E9ECF1]'"
              @click="goTo(index)">
              <span
                class="w-[20px] h-[20px] mobile:mt-[1px] laptop:mt-0 rounded-full flex-shrink-0 flex items-center justify-center "
                :class="index == currentIndex ? 'bg-[#6C79E0]' : 'border-[2px] border-[#CCCCCC]'">
                <span v-if="index == currentIndex" class="w-[8px] h-[8px] rounded-full bg-white" />
              </span>
              <!-- below laptop (Figma mobile): title row, subtitle, then the chips; laptop: title + chips, subtitle below -->
              <span class="flex-1 min-w-0 flex flex-wrap items-center gap-x-[10px] gap-y-[6px]">
                <span
                  class="mobile:basis-full laptop:basis-auto text-[15px] desktop:text-[16px] leading-[22px] font-medium text-[#2E3138]"><template v-if="item.unit_name">{{ item.unit_name ?? 'Unit' }}</template>
                </span>
                <!--  -->
                <span v-if="item.is_agreement == 1"
                  class="mobile:order-3 laptop:order-none flex items-center gap-[8px] h-[30px] px-[10px] rounded-[8px] border-[1px] border-[#C2E2F9] bg-[#E9F5FE] text-[12px] desktop:text-[13px] font-medium text-[#2A7BB8]">
                  <span class="w-[18px] h-[18px] rounded-full flex items-center justify-center bg-[#38BDF8]">
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 64 64">
                      <path d="M0 0h64v64H0z" fill="none" />
                      <path fill="#fff" d="M56 2L18.8 42.909L8 34.729H2L18.8 62L62 2z" />
                    </svg>
                  </span>
                  Service Agreement
                </span>
                <span v-if="item.is_selected == 1"
                  class="mobile:order-3 laptop:order-none min-h-[24px] px-[11px] py-[3px] rounded-[6px] bg-[#6C79E0] text-[12px] leading-[18px] whitespace-nowrap text-white">Selected
                  for this booking</span>
                <span v-else-if="!item.id"
                  class="mobile:order-3 laptop:order-none min-h-[24px] px-[11px] py-[3px] rounded-[6px] bg-[#6C79E0] text-[12px] leading-[18px] whitespace-nowrap text-white">New
                  unit</span>
                <span v-if="unitSubtitle(item, index)"
                  class="basis-full mobile:order-2 laptop:order-none text-[13px] desktop:text-[14px] leading-[19px] text-[#8A9099]">{{
                    unitSubtitle(item, index)
                  }}</span>
              </span>
              <!-- Figma right side: "Last diagnosed MM/DD/YYYY", else "Never Diagnosed" (saved units only; gap G-37) -->
              <span v-if="item.id"
                class="flex items-center gap-[6px] flex-shrink-0 mobile:text-[12px] laptop:text-[13px]"
                :class="lastDiagnosed(item) ? 'text-[#14A44D]' : 'text-[#8A9099]'">
                <span class="mobile:hidden laptop:block w-[6px] h-[6px] rounded-full"
                  :class="lastDiagnosed(item) ? 'bg-[#14A44D]' : 'bg-[#8A9099]'" />
                {{ lastDiagnosed(item) ? 'Last diagnosed ' + lastDiagnosed(item) : 'Never Diagnosed' }}
              </span>
            </button>
          </li>
          <!-- just for mobile -->
          <li v-for="(item, index) in units" :key="index" class="mobile:block tablet:hidden">
            <button type="button"
              class="w-full flex-col mobile:gap-[10px] laptop:gap-[16px] px-[8px] py-[10px] rounded-[10px] text-left flex"
              :class="index == currentIndex ? 'bg-[#F4F5FB] border-[2px] border-[#7C8CE8]' : 'bg-white border-[2px] border-[#E9ECF1]'"
              @click="goTo(index)">
              <span class="min-w-0 flex items-center gap-x-[6px] gap-y-[6px]">
                <div class="flex items-center gap-[6px] w-[55%]">
                  <span
                    class="w-[12px] h-[12px] rounded-full flex-shrink-0 flex items-center justify-center "
                    :class="index == currentIndex ? 'bg-[#6C79E0]' : 'border-[1px] border-[#CCCCCC]'">
                    <span v-if="index == currentIndex" class="w-[4px] h-[4px] rounded-full bg-white" />
                  </span>
                  <span class="text-[13px] leading-tight font-medium text-[#2E3138]"><template v-if="item.unit_name">{{ item.unit_name }}</template>
                  </span>
                </div>
                <span v-if="item.id"
                  class="flex items-center justify-end gap-[6px] flex-shrink-0 text-[11px] w-[45%] text-right"
                  :class="lastDiagnosed(item) ? 'text-[#14A44D]' : 'text-[#8A9099]'">
                  <span class="mobile:hidden laptop:block w-[6px] h-[6px] rounded-full"
                    :class="lastDiagnosed(item) ? 'bg-[#14A44D]' : 'bg-[#8A9099]'" />
                  {{ lastDiagnosed(item) ? 'Last diagnosed ' + lastDiagnosed(item) : 'Never Diagnosed' }}
                </span>
              </span>
              <span v-if="unitSubtitle(item, index)"
              class="basis-full text-[12px] leading-tight text-[#8A9099]">{{
                unitSubtitle(item, index)
              }}</span>
              <div v-if="item.is_agreement == 1 || item.is_selected == 1 || !item.id" class="flex flex-wrap items-center gap-[6px]">
            
                <span v-if="item.is_agreement == 1"
                  class="flex items-center gap-[8px] h-[24px] px-[8px] rounded-[8px] border-[1px] border-[#C2E2F9] bg-[#E9F5FE] text-[11px] font-medium text-[#2A7BB8]">
                  <span class="w-[16px] h-[16px] rounded-full flex items-center justify-center bg-[#38BDF8]">
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 64 64">
                      <path d="M0 0h64v64H0z" fill="none" />
                      <path fill="#fff" d="M56 2L18.8 42.909L8 34.729H2L18.8 62L62 2z" />
                    </svg>
                  </span>
                  Service Agreement
                </span>
                <span v-if="item.is_selected == 1"
                  class="min-h-[24px] px-[8px] py-[3px] rounded-[6px] bg-[#6C79E0] text-[11px] leading-[18px] whitespace-nowrap text-white">Selected
                  for this booking</span>
                <span v-else-if="!item.id"
                  class="min-h-[24px] px-[8px] py-[3px] rounded-[6px] bg-[#6C79E0] text-[11px] leading-[18px] whitespace-nowrap text-white">New
                  unit</span>
              </div>
            </button>
          </li>

        </ul>

        <div v-if="units[currentIndex]"
          class="mb-[10px] font-roboto mt-[15px] pt-[10px] border-t-[1px] border-[#EFEFEF]">
          <label for="unitListNotes" class="block mb-[6px] text-[13px] text-[#5B616B]">Notes <span
              class="text-[#EA8A8A]">(Notes
              cannot exceed 500 characters.)</span></label>
          <textarea id="unitListNotes" v-model="units[currentIndex].notes" maxlength="500" rows="3"
            placeholder="Enter Notes"
            class="w-full px-[14px] py-[10px] rounded-[8px] border-1 border-[#E1E5EF] text-[14px] outline-none focus:border-[#00B7C2] resize-none" />
        </div>

      </template>
      <div v-show="!showList" class="flex flex-wrap items-center justify-between gap-2 mb-[20px]">
        <p class="m-0 text-[14px] laptop:text-[16px] font-roboto text-[#333333]">
          Please review and update the unit information that are currently under evaluation
        </p>
      </div>
      <!-- Figma "Select a Unit - Validation Errors": banner when required fields are missing -->
      <div v-if="missingFieldCount > 0 && !showList"
        class="flex items-center gap-[12px] mb-[20px] px-[18px] py-[8px] rounded-[10px] border-1 border-[#F5C2C2] bg-[#FDECEC] font-roboto">
        <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" class="flex-shrink-0">
          <path fill="#EE5851" d="M12 2 1 21h22z" />
          <path d="M12 9v5M12 17h.01" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" />
        </svg>
        <p class="m-0 text-[13px] leading-[18px] font-medium text-[#C43333]">
          {{ missingFieldCount }} required {{ missingFieldCount == 1 ? 'field is' : 'fields are' }} missing. Complete
          them
          before you can evaluate this unit.
        </p>
      </div>
      <div v-show="!showList" class="carouselSec-selectunit">
        <carousel v-if="units.length > 0 && isUnitsApiHit && !showList" ref="carouselSec" v-model="currentIndex"
          :items-to-show="1" :navigation-enabled="false" adjustable-height="true" :touch-drag="false"
          :mouse-drag="false" @slide-start="pageChange">
          <slide v-for="(item, index) in units" :key="index">
            <unit_detail v-if="index == carouselSlideIndex" :carousel-slide-index="carouselSlideIndex" :item="item"
              :current-index="currentIndex" :units="units" :config-data="configData" :error-object="errorObject"
              @event="unitCallback" @open-modal-q-r="openModalQR" />
          </slide>
        </carousel>
      </div>

      <div class="hidden laptop:flex flex-wrap justify-center items-center gap-[20px]">
        <EvalButton v-if="showList" :disabled="!units.length" @click="openUnitForm()" />
        <template v-else>
          <EvalButton variant="back" @click="backButtonClicked()" />
          <EvalButton v-if="checkIsSave()" @click="saveUnit()">
            Save this unit
          </EvalButton>
          <EvalButton v-else @click="evaluate()" />
        </template>
      </div>

    </EvalShell>

    <div
      class="laptop:hidden absolute -bottom-[20px] left-0 right-0 flex flex-wrap justify-center items-center gap-[20px]">
      <EvalButton v-if="showList" :disabled="!units.length" @click="openUnitForm()" />
      <template v-else>
        <EvalButton variant="back" @click="backButtonClicked()" />
        <EvalButton v-if="checkIsSave()" @click="saveUnit()">
          Save this unit
        </EvalButton>
        <EvalButton v-else @click="evaluate()" />
      </template>
    </div>

    <!-- Figma "Add Unit Modal" (5574-2689): the unit form (same fields + validation as the unit detail) in a right-pinned
         modal; Add Unit saves it to the address and selects it in the list, Add & Evaluate also opens its form -->
    <div ref="addUnitModal" class="modal fade addUnitModal" tabindex="-1" aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!right-0 mobile:!px-3 tablet:px-0 tablet:!w-[500px] tablet:!max-w-[500px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
        <div class="modal-content">
          <div class="modal-body !p-3 !pb-0 font-roboto flex flex-col">
            <FxModalHeader title="Add Unit to this Location" :dismiss="false" @close="closeAddUnit" />
            <div class="flex-1 flex flex-col px-[6px]">
              <p class="mt-[15px] mb-[12px] text-[14px] leading-[20px] text-center text-[#666666]">
                Enter the basics now — you can complete the full specification during its own evaluation.
              </p>
              <div class="fxInfoBox mb-[20px]">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"
                  class="flex-shrink-0 mt-[1px]">
                  <circle cx="12" cy="12" r="9" stroke="#2A7BB8" stroke-width="2" />
                  <path d="M12 11v5M12 8h.01" stroke="#2A7BB8" stroke-width="2" stroke-linecap="round" />
                </svg>
                This unit is registered at the address but is not added to the current booking. Create a separate
                booking
                to diagnose it.
              </div>
              <unit_detail v-if="newUnit" :key="newUnitKey" :carousel-slide-index="0" :item="newUnit" :current-index="0"
                :units="[newUnit]" :config-data="newUnitConfig" :error-object="newUnitErrors" :sections="true"
                @open-modal-q-r="openModalQR" />
            </div>
            <div class="uqcFooter flex flex-wrap items-center justify-center gap-[10px]">
              <button type="button" class="uqcBtnNext" @click="saveNewUnit('add')">Add Unit</button>
              <button type="button"
                class="h-[38px] px-[16px] rounded-[6px] border-1 border-[#00B7C2] bg-[#fff] text-[14px] font-medium text-[#00B7C2] hover:bg-[#E6F8F9]"
                @click="saveNewUnit('evaluate')">Add &amp; Evaluate this Unit</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="qrModals" ref="qrModals" class="modal fade fxModal" tabindex="-1" aria-labelledby="exampleModalLabel"
      aria-hidden="false">
      <div class="modal-dialog modal-dialog-centered" style="max-width: 500px">
        <div class="modal-content">
          <div class="modal-body p-0">
            <div class="modalCntnt pt-1">
              <ModalScanner :show-modal="isQRModalOpen" @close="closeQRModal" @scan-result="handleQRScanResult" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="barcodeModals" ref="barcodeModals" class="modal fade fxModal" tabindex="-1"
      aria-labelledby="exampleModalLabel" aria-hidden="false">
      <div class="modal-dialog modal-dialog-centered" style="max-width: 500px">
        <div class="modal-content">
          <div class="modal-body p-0">
            <div class="modalCntnt pt-1">
              <Scanner :show-modal="isModalOpen" @close="closeModal" @scan-result="handleScanResult" />
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- <StreamBarcodeReader @decode="onDecode" @loaded="onLoaded"></StreamBarcodeReader> -->
  </main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide } from "vue3-carousel";
import { Modal } from "bootstrap";
import unit_detail from "../../components/nest_components/UnitDetail.vue";
import EvalShell from "@/components/nest_components/EvalShell.vue";
import EvalButton from "@/components/nest_components/EvalButton.vue";
import FxModalHeader from "@/components/nest_components/FxModalHeader.vue";
import { disableScroll, enableScroll } from "@/helpers/scrollHelper";
import { isFromMobile } from "@/helpers/embedMode";
import { useToast } from "vue-toastification";
import { evaluationApi } from "@/services/evaluationApi";
import ModalScanner from '../../components/nest_components/ModalScanner.vue';
import Scanner from '../../components/nest_components/Scanner.vue'


const toast = useToast();

export default {
  components: {
    Carousel,
    Slide,
    unit_detail,
    EvalShell,
    EvalButton,
    FxModalHeader,
    ModalScanner,
    Scanner
  },

  data() {
    return {
      currentIndex: 0,
      step: "list", // multiple units: "list" (pick one) → "form"
      jobId: this.$route.params.id,
      units: [],
      // Add Unit modal: its own unit / config / errors, so the list's units are not touched until it is saved
      newUnit: null,
      newUnitKey: 0,
      newUnitConfig: [null],
      newUnitErrors: {},
      // "add" | "evaluate" while the new unit is saved and the list reloads; ids before the save find the new one
      addingUnit: "",
      unitIdsBeforeAdd: [],
      isUnitsApiHit: false,
      isFixed: false,
      configData: [],
      // list subtitles: config per "system-product-heat" type. configData only has the units whose form was opened,
      // so after Back (list first, no form yet) the tonnage was missing
      listConfigs: {},
      isSaveUnit: false,
      carouselSlideIndex: 0,
      isModalOpen: false,
      isQRModalOpen: false,
      selectedKey: '',
      errorObject: {},
      is_from_mobile: this.$route.query.is_from_mobile,
    };
  },

  computed: {
    // required fields flagged by isValid() (cleared as the user fills them)
    missingFieldCount() {
      return Object.values(this.errorObject || {}).filter(Boolean).length;
    },
    ...mapGetters([
      "unitsList",
      "apiCallback",
      "postUnitResponse",
      "bindUnitResponse",
      "bookingResponse",
      "previousEvaluation",
      "preConfig",
    ]),

    // the unit list always comes first (also with 0 or 1 unit); Next opens the picked unit's form
    showList() {
      return this.isUnitsApiHit && this.step === "list";
    },
    // mobile app webview: the unit list has no Back at the bottom (only Next), so no grey back on top either
    hideTopBack() {
      return this.showList && isFromMobile(this.$route);
    },
    isMobile() {
      return this.isMobileDevice();
    },
    totalSlides() {
      return this.units.length;
    },
  },

  watch: {
    preConfig() {
      this.loadListConfigs();
    },

    unitsList: function () {
      if (this.isSaveUnit) {
        this.isSaveUnit = false;
        for (let key in this.units) {
          this.units[key].id = this.unitsList[key].id;
        }
      } else {
        this.units = this.unitsList || [];
        this.getPreConfig();
        this.loadListConfigs();

        // after Add Unit: select the unit that wasn't there before (and open its form for Add & Evaluate)
        const added = this.addingUnit
          ? this.units.findIndex(u => !this.unitIdsBeforeAdd.includes(String(u.id)))
          : -1;
        const index = added !== -1 ? added : this.units.findIndex(item => item.is_selected == 1);
        if (index !== -1) {
          setTimeout(() => {
            this.currentIndex = index
            this.$nextTick(() => this.showUnitInList(index));
            if (added !== -1 && this.addingUnit === "evaluate") this.openUnitForm();
            this.addingUnit = "";
          }, 50);
        } else {
          this.addingUnit = "";
        }
        this.isUnitsApiHit = true;

      }
    },

    // clear a field's error in the Add Unit modal once it has a value
    newUnit: {
      handler(unit) {
        for (const key in unit || {}) if (!this.isEmpty(unit[key])) this.newUnitErrors[key] = false;
      },
      deep: true,
    },

    'units': {
      handler(nval, oVal) {
        let newVal = nval[this.currentIndex]
        let oldVal = oVal ?? nval[this.currentIndex]
        for (const key in newVal) {
          if (newVal[key] !== oldVal[key]) {
            this.errorObject[key] = false
          }
        }
      },
      deep: true,
      immediate: true
    },

    postUnitResponse: function () {
      if (this.isSaveUnit || this.addingUnit) {
        this.getUnitsData();
      } else {
        this.bindUnit({
          job_id: this.jobId,
          job_type: "1",
          unit_id: this.units[this.currentIndex].id,
        });
      }
    },

    previousEvaluation: function () {
      if (this.previousEvaluation) {
        if (this.previousEvaluation?.options?.length > 0) {
          this.$router.push({
            path: `/last-evaluation/${this.$route.params.id}`,
            query: {
              unit_id: this.units[this.currentIndex].id,
              is_from_mobile: this.$route.query.is_from_mobile,
            },
          });
        } else {
          this.$router.push({
            path: `/equipment/${this.$route.params.id}`,
            query: {
              unit_id: this.units[this.currentIndex].id,
              is_from_mobile: this.$route.query.is_from_mobile,
            },
          });
        }
      }
    },

    bindUnitResponse: function () {
      this.getPreviousEvaluation({
        booking_id: this.jobId,
        unit_id: this.units[this.currentIndex].id,
      });
    },

    apiCallback: function () { },
    bookingResponse: function () {
      this.handleBookingResponse();
    },
  },

  mounted() {
    this.getBookingDetails({
      booking_id: this.jobId,
    });
    window.addEventListener("scroll", this.handleScroll);
  },

  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    // Figma unit row subtitle, e.g. "Attic · Split · Heat Pump · 3.0 Ton" — built from the unit's ids
    unitSubtitle(item, index) {
      const cfg = this.listConfigs[this.configKey(item)]
        || (this.configData[index]?.questions_top ? this.configData[index] : this.configData.find(c => c && c.questions_top));
      const optionTitle = (name, id) => {
        if (id == null || !cfg) return '';
        for (const section of ['questions_top', 'questions_bottom']) {
          const question = cfg[section]?.data?.find(d => d.name === name);
          const option = question?.options?.find(o => String(o.id) === String(id));
          if (option) return option.title;
        }
        return '';
      };
      const systemType = this.preConfig?.system_types?.find(t => String(t.id) === String(item.system_type_id));
      const productType = systemType?.product_types?.find(t => String(t.id) === String(item.product_type_id));
      const heatType = productType?.heat_types?.find(t => String(t.id) === String(item.heat_type_id));
      return [
        // *_title: sent by units-new/list once G-75 is done; until then looked up in the unit type's config
        item.location_title || optionTitle('location_id', item.location_id) || optionTitle('system_placement_id', item.system_placement_id),
        systemType?.name,
        heatType?.value,
        // tonnage; units without one (heating only) show their heating BTU
        ((t) => (t && /^\d+(\.\d+)?$/.test(t) ? t + ' Ton' : t))(item.tonnage_title || optionTitle('tonnage_id', item.tonnage_id))
        || ((b) => (b && !/btu/i.test(b) ? b + ' BTU' : b))(item.heating_btu_title || optionTitle('heating_btu_id', item.heating_btu_id)),
      ].filter(Boolean).join(' · ');
    },

    configKey(item) {
      return [item.system_type_id, item.product_type_id, item.heat_type_id].join("-");
    },
    // one config call per unit type (cooling-only units have no heat type)
    async loadListConfigs() {
      if (!this.preConfig?.system_types) return;
      for (const item of this.units) {
        const key = this.configKey(item);
        // the list already sends a title (G-75): no config needed (null titles still need it)
        if (item.tonnage_title || item.heating_btu_title) continue;
        if (!item.system_type_id || !item.product_type_id || key in this.listConfigs) continue;
        const product = this.preConfig.system_types.find(t => String(t.id) === String(item.system_type_id))
          ?.product_types?.find(p => String(p.id) === String(item.product_type_id));
        const cooling = product?.slug === "cooling";
        if (!cooling && !item.heat_type_id) continue;
        this.listConfigs[key] = null; // in flight
        const res = await evaluationApi.unitConfig({
          system_type_id: item.system_type_id,
          product_type_id: item.product_type_id,
          ...(cooling ? {} : { heat_type_id: item.heat_type_id }),
        });
        this.listConfigs[key] = res.ok ? res.body : null;
      }
    },

    ...mapActions([
      "getUnitList",
      "getBootMeData",
      "getPreConfig",
      "getConfig",
      "postUnitDetails",
      "bindUnit",
      "getBookingDetails",
      "getPreviousEvaluation",
    ]),
    // the unit list is its own scroll box: bring the selected unit into view (centred) without moving the page
    showUnitInList(index) {
      const list = this.$refs.unitList;
      const row = list?.children?.[index];
      if (!row) return;
      list.scrollTop += row.getBoundingClientRect().top - list.getBoundingClientRect().top - (list.clientHeight - row.offsetHeight) / 2;
    },
    goTo(index) {
      if (index < 0 || index >= this.units.length) return;
      this.currentIndex = index;
    },
    handleBookingResponse() {
      if (this.bookingResponse !== null) {
        this.getUnitsData();
      }
    },

    evaluate() {
      if (this.isValid()) {
        if ((this.bookingResponse?.unit_id ?? '-1') != '-1' && this.units[this.currentIndex].id != (this.bookingResponse?.unit_id ?? '')) {
          this.$dialog.show({
            title: "Confirmation",
            text: "Starting a new evaluation will discard the current diagnosis. Do you want to continue?",
            onConfirm: () => {
              this.postUnitDetails({
                source_id: this.jobId,
                source: "booking",
                units: JSON.stringify(this.units),
              });
            },
          });
        } else {
          this.postUnitDetails({
            source_id: this.jobId,
            source: "booking",
            units: JSON.stringify(this.units),
          });
        }
      }
    },

    getUnitsWithIds() {
      return this.units.filter(function (item) {
        return item.id + "" != "undefined";
      });
    },

    chipSelection(ind) {
      this.currentIndex = ind;
    },

    backButtonClicked() {
      if (this.step === "form") {
        this.step = "list";
        this.errorObject = {};
        window.scrollTo({ top: 0 });
        return;
      }
      this.$router.go(-1);
    },
    openUnitForm() {
      this.step = "form";
      window.scrollTo({ top: 0 });
      // the carousel measured 0px while the list hid it: re-measure, then show the picked unit
      this.$nextTick(() => {
        const carousel = this.$refs.carouselSec;
        carousel?.updateSlideWidth();
        carousel?.slideTo(this.currentIndex);
        this.carouselSlideIndex = this.currentIndex;
      });
    },
    // "MM/DD/YYYY" when the unit list sends a last-diagnosis date (epoch or date string), "" = never / not sent
    lastDiagnosed(item) {
      const raw = item.last_diagnosed_at ?? item.last_diagnosed ?? item.last_evaluation_date;
      if (!raw) return "";
      const d = new Date(/^\d+$/.test(String(raw)) ? Number(raw) * 1000 : raw);
      if (isNaN(d)) return String(raw);
      const pad = (n) => String(n).padStart(2, "0");
      return `${pad(d.getMonth() + 1)}/${pad(d.getDate())}/${d.getFullYear()}`;
    },

    checkIsSave() {
      if (this.units[this.currentIndex] && this.units[this.currentIndex].id) {
        return false;
      } else {
        return true;
      }
    },

    saveUnit() {
      if (this.isValid()) {
        this.isSaveUnit = true;
        this.postUnitDetails({
          source_id: this.jobId,
          source: "booking",
          units: JSON.stringify(this.units),
        });
      }
    },

    addMoreUnits() {
      if (this.units.length >= 20) {
        toast.error("You can not add more than 20 units.");
        return;
      }
      this.newUnit = { unit_name: "" };
      this.newUnitConfig = [null];
      this.newUnitErrors = {};
      this.newUnitKey++;
      disableScroll();
      Modal.getOrCreateInstance(this.$refs.addUnitModal, { backdrop: "static", keyboard: false }).show();
    },

    closeAddUnit() {
      Modal.getInstance(this.$refs.addUnitModal)?.hide();
      enableScroll();
      this.newUnit = null;
    },

    // same save as "Save this unit": all saved units + the new one; the list then reloads and selects it
    saveNewUnit(mode) {
      if (!this.isValid(this.newUnit, this.newUnitConfig[0] ?? null, this.newUnitErrors, 0)) return;
      const saved = this.units.filter(u => u.id);
      this.unitIdsBeforeAdd = saved.map(u => String(u.id));
      this.addingUnit = mode;
      this.postUnitDetails({
        source_id: this.jobId,
        source: "booking",
        units: JSON.stringify([...saved, this.newUnit]),
      });
      this.closeAddUnit();
    },

    getUnitsData() {
      this.getUnitList({
        booking_id: this.$route.params.id,
      });
    },

    jobDetailClicked() {
      this.$router.go(-1);
    },

    unitCallback(option, index) {
      if (option == "delete") {
        this.units.splice(index, 1);
        this.configData.splice(index, 1);
        this.currentIndex = index - 1;
      }
    },

    handleScroll() {
      const scroll = window.scrollY;
      this.isFixed = scroll >= 200;
    },

    disablePaste(event) {
      event.preventDefault();
    },

    isNumber(evt) {
      //validate
      const inputElement = evt.target;
      let value = inputElement.value;
      if (evt.type === 'input') {
        value = value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
        const [integer, decimal] = value.split('.');
        if (integer.length > 4) value = integer.slice(0, 4);
        if (decimal) {
          if (integer === "") {
            value = "";
          } else {
            value = `${integer}.${decimal.slice(0, 2)}`;
          }
        }
        if (value.startsWith('.') || value === '') {
          value = '';
        }
        // re-dispatch only on a change, otherwise this @input handler calls itself forever (QA D-46)
        if (inputElement.value !== value) {
          inputElement.value = value;
          inputElement.dispatchEvent(new Event('input', { bubbles: true }));
        }
      } else if (evt.type === 'keypress') {
        const charCode = evt.which || evt.keyCode;
        if (charCode === 8 || charCode === 46 || charCode === 9 || (charCode >= 48 && charCode <= 57)) {
          if (charCode === 46 && value.indexOf('.') !== -1) {
            evt.preventDefault();
            return false;
          }
          return true;
        }
        evt.preventDefault();
        return false;
      }
      // Remove invalid characters and multiple decimal points
      value = value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
      const [integer, decimal] = value.split('.');
      // Restrict length
      if (integer.length > 4) value = integer.slice(0, 4);
      if (decimal) value = value.split('.')[0] + '.' + decimal.slice(0, 2);
      inputElement.value = value;
    },

    isEmpty(value) {
      return (
        value == null ||
        value == undefined ||
        value.length == 0 ||
        (value.constructor === Object && Object.keys(value).length === 0)
      );
    },

    isValidRequired(key, unit = this.units[this.currentIndex]) {
      if (
        key == "new_capacity" &&
        unit["is_system_sized_properly"] == "1"
      ) {
        return false;
      } else if (key == "notes") {
        return false;
      } else if (key == "coil_model") {
        return false;
      } else {
        return true;
      }
    },

    isAddOptionCheck() {
      if (
        this.bookingResponse &&
        this.bookingResponse.is_partner_job == '1' &&
        this.bookingResponse.depp_schedule &&
        this.bookingResponse.depp_schedule.is_allied == "1" &&
        this.bookingResponse.depp_schedule.number_of_equipment_items_covered <=
        1
      ) {
        return false;
      } else {
        return true;
      }
    },

    // the page form by default; the Add Unit modal passes its own unit / config / errors (field ids "0-…")
    isValid(unit = this.units[this.currentIndex], config = this.configData[this.currentIndex] ?? null,
      errors = this.errorObject, idIndex = this.currentIndex) {
      let res = true;
      let index = -1;

      if (this.isEmpty(unit.unit_name)) {
        errors['unit_name'] = true
        if (index == -1) {
          index = idIndex + '-unit_name';
        }
        res = false;
      } if (this.isEmpty(unit.manufacturer)) {
        errors['manufacturer'] = true
        if (index == -1) {
          index = idIndex + '-manufacturer';
        }
        res = false;
      } if (this.isEmpty(unit.manufacture_date)) {
        errors['manufacture_date'] = true
        if (index == -1) {
          index = idIndex + '-manufacture_date';
        }
        res = false;
      } if (this.isEmpty(unit.system_type_id)) {
        errors['system_type_id'] = true
        if (index == -1) {
          index = idIndex + '-system_type_id';
        }
        res = false;
      } if (this.isEmpty(unit.product_type_id)) {
        errors['product_type_id'] = true
        if (index == -1) {
          index = idIndex + '-product_type_id';
        }
        res = false;
      } if (unit['is_cooling_only'] == 0 && this.isEmpty(unit.heat_type_id)) {
        errors['heat_type_id'] = true
        if (index == -1) {
          index = idIndex + '-heat_type_id';
        }
        res = false;
      } if (config == null) {
        res = false;
      }

      if (config) {
        for (var key in config) {
          if (config.hasOwnProperty(key)) {
            if (key != "indoor" && key != "outdoor") {
              for (var indx in config[key].data) {
                let dataItems = config[key].data[indx];
                let dataKey = dataItems.name;
                let value = unit[dataItems.name];
                if (this.isValidRequired(dataKey, unit) && this.isEmpty(value)) {
                  res = false;
                  errors[dataItems.name] = true
                  if (index == -1) {
                    index = idIndex + '-' + dataItems.name;
                  }
                  // break outerLoop;
                }
              }
            }
          }
        }
      }

      if (!res) {
        toast.error("All fields are required.");
        document.getElementById("" + index)?.scrollIntoView({ behavior: "smooth", block: "center" });
      }

      return res;
    },

    pageChange(i) {
      this.errorObject = {}
      this.carouselSlideIndex = i.slidingToIndex ?? 0;
    },

    isMobileDevice() {
      return window.screen.width < 1200 ? false : true;
    },

    closeModal() {
      this.isModalOpen = false;
      this.modal.hide();
    },

    closeQRModal() {
      this.isQRModalOpen = false;
      this.modal.hide();
    },


    handleQRScanResult(result) {
      (this.newUnit || this.units[this.currentIndex])[this.selectedKey] = result
      // Yahan aap scanned result ko process kar sakte hain, jaise ke API call ya local state update.
      this.modal.hide();
    },

    handleScanResult(result) {
      (this.newUnit || this.units[this.currentIndex])[this.selectedKey] = result
      // Yahan aap scanned result ko process kar sakte hain, jaise ke API call ya local state update.
      this.modal.hide();
    },

    openModalQR(item, type) {
      //barcodeModals
      if (type == 'barcode') {
        this.selectedKey = item
        this.isModalOpen = true;
        this.modal = new Modal(this.$refs.barcodeModals);
        this.modal.show();
      }
      else {
        this.selectedKey = item
        this.isQRModalOpen = true;
        this.modal = new Modal(this.$refs.qrModals);
        this.modal.show();
      }

    }

  },
};
</script>

<style>
/* Add Unit modal is 500px: UnitDetail's viewport columns (col-lg-4…) stack to one per row */
.addUnitModal .unitSelection .row>[class*="col-"] {
  flex: 0 0 100%;
  max-width: 100%;
}

@media (max-width: 1024px) {

  .carouselSec-selectunit .carousel__prev,
  .carouselSec-selectunit .carousel__prev:hover {
    left: 28% !important;
  }

  .carouselSec-selectunit .carousel__next,
  .carouselSec-selectunit .carousel__next:hover {
    right: 28% !important;
  }
}

@media (max-width: 1200px) {

  .carouselSec-selectunit .carousel__prev,
  .carouselSec-selectunit .carousel__prev:hover {
    left: 31% !important;
  }

  .carouselSec-selectunit .carousel__next,
  .carouselSec-selectunit .carousel__next:hover {
    right: 31% !important;
  }
}

@media (max-width: 1366px) {

  .carouselSec-selectunit .carousel__prev,
  .carouselSec-selectunit .carousel__prev:hover {
    left: 34% !important;
  }

  .carouselSec-selectunit .carousel__next,
  .carouselSec-selectunit .carousel__next:hover {
    right: 34% !important;
  }
}

.carousel__slide {
  display: table !important;
}

.unitSelection {
  width: 85% !important;
  margin: 0 auto;
}

.chipsSec button {
  border: 0;
  background: transparent;
  color: #000;
  border-radius: 50px;
  border: 1px solid #000;
  padding: 0.1rem 1rem;
}

/* .carousel__slide--active button {
  background: #000;
  color: #fff;
} */

li.carousel__pagination-item {
  width: 30px;
  height: 30px;
  position: relative;
  top: 0;
  margin: 0 0.1rem;
}

.carousel__prev,
.carousel__next {
  top: auto;
  bottom: -2px;
}

.carousel__prev,
.carousel__prev:hover {
  left: 36%;
  border: 1px solid #fe5000;
  background: #fe5000;
  border-radius: 50%;
  color: #fff;
  bottom: -17px !important;
}

.carousel__next,
.carousel__next:hover {
  right: 36%;
  border: 1px solid #fe5000;
  background: #fe5000;
  border-radius: 50%;
  color: #fff;
  bottom: -17px !important;
}

.carousel__prev--disabled,
.carousel__next--disabled {
  border: 1px solid #fe5000;
  color: #fe5000;
  background: transparent;
  opacity: 1;
}

button.carousel__pagination-button {
  width: 30px;
  height: 30px;
  position: relative;
  top: -14px;
  padding: 0;
  left: -20px;
  border-radius: 50%;
  /* z-index: -1; */
}

.carousel__pagination-button--active:after {
  background: #092e87 !important;
}

button.carousel__pagination-button:after {
  /* opacity: 0; */
  width: 30px;
  height: 30px;
  z-index: 99;
  /* left: -10px; */
  border: 1px solid #ccc;
  background: transparent;
  border-radius: 50%;
  z-index: -1;
  position: relative;
}

.carousel__pagination {
  counter-reset: carousel-counter;
  /* Initialize the counter */
  padding: revert-layer;
  margin-top: 30px;
}

.carousel__pagination-item {
  counter-increment: carousel-counter;
  /* Increment the counter for each li */
  list-style: none;
  /* Remove default bullets */
}

.carousel__pagination-item::marker {
  font-size: 16px;
  content: counter(carousel-counter);
  /* Display the counter value */
  margin-right: 8px;
  /* Add some space between the number and the text */
  color: #ccc;
  z-index: 1;
}

.chipsSec ul li {
  /* width: 30%; */
  margin: 0.2rem;
}

.chipsSec ul li button.active {
  background: #000;
  color: #fff;
}

.carousel__viewport {
  margin-bottom: 30px;
  overflow: visible !important;
}
</style>
